
export const siteConfig = {
  brandName: "SANTI BLADEZ",
  owner: "Santiago",
  phone: "+1 (555) 742-7725",
  email: "hello@santibladez.com",
  bookingUrl: "https://booksy.com",
  googleCalendarUrl: "https://calendar.google.com/calendar/u/0/appointments/schedules/placeholder",
  businessCardUrl: "https://hihello.com/p/c90cf659-0588-409f-8753-4a96c8f76d2e",
  businessCardQrCode: "1HghUUzWad72Nci_Ue4sRPt3ord2jMZhF",
  socials: {
    instagram: "https://instagram.com",
    facebook: "https://facebook.com",
    twitter: "https://twitter.com",
    youtube: "https://youtube.com",
    tiktok: "https://tiktok.com"
  },
  services: [
    {
      id: "signature-house-call",
      price: 180,
      duration: "90 MINS"
    }
  ],
  videos: {
    homeFeatured: "https://drive.google.com/file/d/1yz4zBVz2KKoZXAn1maf1Viq6tiJZPd1s/preview",
    masteryReels: [
      { id: "1157692458", title: "SHARP BLADEZ V3" },
      { id: "1157692552", title: "C1 Reel no Logo" },
      { id: "1157692529", title: "Executive Precision" },
      { id: "1157692498", title: "IMG_0801 Mastery" },
      { id: "1157692479", title: "IMG_8138 Detail" },
      { id: "1157692470", title: "IMG_9496 Signature" }
    ],
    driveArchive: [
      { id: "1DxU1Mr6lsw8SNwiIU36IDHkxdbxBKNCa", title: "Signature Fade" },
      { id: "1j9FbYtuU3wqEXUyeN-7pJOyHXu8L0aki", title: "Taper Flow" },
      { id: "1youN4K137z4xRNvOavvsjjHN_a0Ma8MA", title: "Geometric Design" },
      { id: "1_wrdNffysiSZi_IuDOLo98f_4okOt3d9", title: "Studio Detail" },
      { id: "1viSEgOXceZcDdhMYCmXwfO5hg8Ia7pQl", title: "The Masterpiece" },
      { id: "1OzqlkrJCW7_SbEYZBy57DNw_3NxsKCff", title: "Executive Sculpt" },
      { id: "1ZnOSiZwBL_3u_nIT-IKDzvfxjBjH-oYT", title: "Precision Beard" },
      { id: "1kQK6s95hGlo4kuwOIGroFJorjV71R378", title: "Blade Artistry" },
      { id: "1euLWA3QMtH_3pWgYVHTnLm0aLevGpMdp", title: "Modern Texture" }
    ]
  },
  images: {
    heroFallback: "https://drive.google.com/thumbnail?id=1DxU1Mr6lsw8SNwiIU36IDHkxdbxBKNCa&sz=w1200",
    logo: "https://i.ibb.co/4RPJWXW5/logo-1w420fzfl.jpg",
    portfolio: [
        "https://drive.google.com/thumbnail?id=1DxU1Mr6lsw8SNwiIU36IDHkxdbxBKNCa&sz=w600",
        "https://drive.google.com/thumbnail?id=1OzqlkrJCW7_SbEYZBy57DNw_3NxsKCff&sz=w600",
        "https://drive.google.com/thumbnail?id=1euLWA3QMtH_3pWgYVHTnLm0aLevGpMdp&sz=w600"
    ],
    vipRoom: [
      "https://drive.google.com/thumbnail?id=1_wrdNffysiSZi_IuDOLo98f_4okOt3d9&sz=w1200",
      "https://drive.google.com/thumbnail?id=1DxU1Mr6lsw8SNwiIU36IDHkxdbxBKNCa&sz=w1200"
    ],
    brandStory: "https://drive.google.com/thumbnail?id=1viSEgOXceZcDdhMYCmXwfO5hg8Ia7pQl&sz=w1200",
  },
  translations: {
    en: {
      tagline: "THE ELITE MOBILE GROOMING EXPERIENCE",
      menu: "Menu",
      bookConcierge: "BOOK NOW",
      heroSignature: "FRESH CUTS",
      heroArtistry: "AT YOUR DOORSTEP",
      featuredPremiere: "Featured Premiere: The Blade Narrative",
      reserveExperience: "Reserve Experience",
      exploreMastery: "Explore Mastery",
      privateMastery: "PRIVATE MASTERY",
      eliteGrooming: "ELITE GROOMING",
      conciergeCuts: "CONCIERGE CUTS",
      mobileLuxury: "MOBILE LUXURY",
      signatureStyle: "SIGNATURE STYLE",
      exclusiveOffering: "The Exclusive Offering",
      signatureHouseCall: "THE SIGNATURE HOUSE CALL",
      experienceDesc: "Santi provides a comprehensive grooming session that respects your time and elevates your image. No menu, no tiers—just the highest standard of barbering.",
      includedHeader: "Included in every session:",
      includedItems: [
        "Elite Lifestyle Consultation",
        "Master Haircut & Reshaping",
        "Precision Beard Sculpting",
        "Straight Razor Edge-up",
        "Invigorating Scalp Massage",
        "Premium Product Styling"
      ],
      mobileSetupNote: "Full mobile setup provided by Santi.",
      bookTheCall: "Book The Call",
      eliteExclusivity: "Elite Exclusivity",
      vipExperience: "SANTI BLADEZ EXPERIENCE",
      eliteSignatureCall: "The Elite Signature Call",
      singleInvestment: "Single Investment",
      vipQuote: "A house call isn't just about convenience—it's about the focused, uninterrupted mastery of your image.",
      vipChecklist: [
        "Priority Scheduling",
        "Full Mobile Studio Setup",
        "Zero Travel Fees (Core Zones)",
        "Consultation & Scalp Treatment",
        "Premium Finishing Products",
        "Straight Razor Detailing"
      ],
      requestAppointment: "Request Appointment",
      privateServiceHeader: "Elite Private Service",
      privateServiceDesc: "Every house call is a transformation of your space into a private salon. Santi brings the specialized lighting, ergonomic seating, and precision tools required for master-level artistry.",
      absolutePrivacy: "Absolute Privacy & Mastery",
      verifiedTestimonials: "Verified Testimonials",
      clientVoice: "THE CLIENT VOICE",
      readAllChronicles: "Read All Chronicles",
      availability: "Availability",
      southFlorida: "SOUTH FLORIDA",
      locationsQuote: "Serving Miami, Fort Lauderdale, Palm Beach & beyond. Wherever you need the blade, Santi travels to you.",
      bookYourLocation: "Book Your Location",
      inquireDirectly: "Inquire Directly",
      footerDesc: "Personal craftsmanship meets mobile luxury. Dedicated to elevating the standard of grooming for the modern gentleman.",
      navTitle: "Navigation",
      conciergeTitle: "Concierge",
      staySharp: "Stay Sharp",
      staySharpDesc: "Join Santi's elite roster for exclusive style drops.",
      brandStoryTitle: "MY STORY",
      brandStoryTagline: "From Pereira to Miami",
      brandTouch: "THE JOURNEY OF THE BLADE",
      brandDesc1: "My journey began in the vibrant neighborhoods of Pereira, Colombia. It wasn't in a luxury salon, but on the front porches of my community, where I learned that a haircut is more than just grooming—it's a transformation of confidence. With nothing but a pair of clippers and a relentless drive, I spent years mastering the geometry of the face and the architecture of hair.",
      brandDesc2: "Arriving in South Florida, I brought that same 'Paisa' work ethic. I saw a gap in the market: the modern gentleman doesn't want to wait in a crowded shop; he craves privacy, precision, and a personal connection. Today, I bring the entire shop experience to your doorstep, combining my Colombian roots with world-class artistry to serve the elite of Miami and beyond.",
      officialFilm: "The Evolution Film",
      brandQuote: "I don't just cut hair; I carry the heritage of Pereira craftsmanship to every home I visit, curating an image that reflects your success.",
      myEvolution: "MY EVOLUTION",
      coreStandards: "MY CORE STANDARDS",
      coreValues: [
        { title: "Personal Privacy", text: "Grooming in the comfort of your chosen location, away from the crowds." },
        { title: "Elite Mastery", text: "Over a decade of expertise, now distilled into a one-on-one mobile experience." },
        { title: "Concierge Flow", text: "Seamless booking, priority SMS scheduling, and complete mobile flexibility." }
      ],
      faqTitle: "SANTI'S MOBILE FAQ",
      grandArchive: "THE GRAND ARCHIVE",
      visualPortfolio: "The Visual Portfolio",
      galleryDesc: "Every cut is a cinematic experience. Explore the full documentation of Santi's craftsmanship, from signature fades to executive sculpting.",
      cinematicReels: "CINEMATIC REELS",
      signatureArchive: "SIGNATURE ARCHIVE",
      readyMasterpiece: "Ready For Your Masterpiece?",
      backToHome: "Back To Home",
      bookNow: "BOOK NOW",
      businessCard: "Business Card",
      reviews: [
        { author: "James R.", text: "Having Santi come to my office was a game changer. The quality of the fade is literally the best I've ever had.", date: "2 weeks ago" },
        { author: "Michael B.", text: "Truly premium. Santi brings a full shop experience to your living room. The straight razor work is impeccable.", date: "1 month ago" },
        { author: "David L.", text: "The convenience of a world-class house call is something I can't go back from. Perfect precision every time.", date: "3 days ago" }
      ],
      milestones: [
        { year: "2012", title: "The Pereira Spark", description: "Santi picks up his first clippers in Colombia, practicing on friends and family." },
        { year: "2018", title: "The Journey North", description: "Moving to Florida with a dream, Santi begins refining his skills in high-end studios." },
        { year: "2024", title: "Santi Bladez Elite", description: "Launching a 100% mobile concierge service, dedicated to the city's most discerning clients." }
      ],
      faq: [
        { q: "What does the $180 include?", a: "The Signature House Call is an all-inclusive experience: travel to your location, a deep consultation, master haircut, precision beard work, and a hot towel finish with premium styling products." },
        { q: "How far do you travel?", a: "Santi provides his signature mobile service all over South Florida. For locations significantly outside the metropolitan core, a small concierge fee may apply." },
        { q: "What do I need to provide?", a: "Just a standard chair and access to a power outlet. Santi brings the lighting, tools, and professional setup." }
      ]
    },
    es: {
      tagline: "LA EXPERIENCIA ÉLITE DE PELUQUERÍA MÓVIL",
      menu: "Menú",
      bookConcierge: "BOOK NOW",
      heroSignature: "CORTES FRESCOS",
      heroArtistry: "A SU PUERTA",
      featuredPremiere: "Estreno Destacado: La Narrativa de la Cuchilla",
      reserveExperience: "Reservar Experiencia",
      exploreMastery: "Explorar Maestría",
      privateMastery: "MAESTRÍA PRIVADA",
      eliteGrooming: "CUIDADO ÉLITE",
      conciergeCuts: "CORTES CONCIERGE",
      mobileLuxury: "LUJO MÓVIL",
      signatureStyle: "ESTILO ÚNICO",
      exclusiveOffering: "La Oferta Exclusiva",
      signatureHouseCall: "EL SERVICIO A DOMICILIO",
      experienceDesc: "Santi ofrece una sesión de cuidado integral que respeta su tiempo y eleva su imagen. Sin menús complicados—solo el más alto estándar en peluquería.",
      includedHeader: "Incluido en cada sesión:",
      includedItems: [
        "Consulta de Estilo Élite",
        "Corte de Cabello Maestro",
        "Esculpido de Barba de Precisión",
        "Perfilado con Navaja",
        "Masaje Capilar Vigorizante",
        "Acabado con Productos Premium"
      ],
      mobileSetupNote: "Santi proporciona todo el equipo móvil necesario.",
      bookTheCall: "Reservar Cita",
      eliteExclusivity: "Exclusividad Élite",
      vipExperience: "EXPERIENCIA SANTI BLADEZ",
      eliteSignatureCall: "La Cita Élite a Domicilio",
      singleInvestment: "Inversión Única",
      vipQuote: "Una visita a domicilio no es solo conveniencia—es la maestría enfocada e ininterrumpida de su imagen.",
      vipChecklist: [
        "Programación Prioritaria",
        "Estudio Móvil Completo",
        "Sin Cargos de Viaje (Zonas Centrales)",
        "Consulta y Tratamiento Capilar",
        "Productos de Acabado Premium",
        "Detallado con Navaja"
      ],
      requestAppointment: "Solicitar Cita",
      privateServiceHeader: "Servicio Privado Élite",
      privateServiceDesc: "Cada visita a domicilio transforma su espacio en un salón privado. Santi trae la iluminación especializada, el asiento ergonómico y las herramientas de precisión requeridas.",
      absolutePrivacy: "Privacidad y Maestría Absoluta",
      verifiedTestimonials: "Testimonios Verificados",
      clientVoice: "LA VOZ DEL CLIENTE",
      readAllChronicles: "Leer Todas las Crónicas",
      availability: "Disponibilidad",
      southFlorida: "SUR DE FLORIDA",
      locationsQuote: "Sirviendo a Miami, Fort Lauderdale, Palm Beach y más allá. Donde necesite la navaja, Santi viaja hacia usted.",
      bookYourLocation: "Reservar Ubicación",
      inquireDirectly: "Consultar Directamente",
      footerDesc: "Artesanía personal combinada con lujo móvil. Dedicado a elevar el estándar del cuidado masculino moderno.",
      navTitle: "Navegación",
      conciergeTitle: "Conserjería",
      staySharp: "Mantente Sharp",
      staySharpDesc: "Únete a la lista élite de Santi para lanzamientos exclusivos.",
      brandStoryTitle: "MI HISTORIA",
      brandStoryTagline: "De Pereira a Miami",
      brandTouch: "EL VIAJE DE LA CUCHILLA",
      brandDesc1: "Mi viaje comenzó en los vibrantes barrios de Pereira, Colombia. No fue en un salón de lujo, sino en los porches de mi comunidad, donde aprendí que un corte de cabello es más que estética—es una transformación de la confianza. Con nada más que un par de máquinas y un impulso implacable, pasé años dominando la geometría del rostro.",
      brandDesc2: "Al llegar al sur de Florida, traje esa misma ética de trabajo 'Paisa'. Vi un vacío en el mercado: el caballero moderno no quiere esperar en una barbería concurrida; busca privacidad y precisión. Hoy, llevo la experiencia completa a su puerta, combinando mis raíces colombianas con un arte de clase mundial para servir a la élite de Miami.",
      officialFilm: "La Película de la Evolución",
      brandQuote: "No solo corto cabello; llevo la herencia de la artesanía de Pereira a cada hogar que visito, curando una imagen que refleja su éxito.",
      myEvolution: "MY EVOLUTION",
      coreStandards: "MIS ESTÁNDARES",
      coreValues: [
        { title: "Privacidad Personal", text: "Cuidado en la comodidad de su ubicación elegida, lejos de las multitudes." },
        { title: "Maestría Élite", text: "Más de una década de experiencia, ahora destilada en una experiencia móvil personalizada." },
        { title: "Flujo Concierge", text: "Reserva perfecta, programación prioritaria por SMS y completa flexibilidad móvil." }
      ],
      faqTitle: "PREGUNTAS FRECUENTES",
      grandArchive: "EL GRAN ARCHIVE",
      visualPortfolio: "Portafolio Visual",
      galleryDesc: "Cada corte es una experiencia cinematográfica. Explore la documentación completa de la artesanía de Santi.",
      cinematicReels: "REELS CINEMATOGRÁFICOS",
      signatureArchive: "ARCHIVO DE AUTOR",
      readyMasterpiece: "¿Listo para su Obra Maestra?",
      backToHome: "Volver al Inicio",
      bookNow: "RESERVAR",
      businessCard: "Tarjeta de Presentación",
      reviews: [
        { author: "James R.", text: "Que Santi venga a mi oficina cambió las reglas del juego. La calidad del fade es literalmente la mejor que he tenido.", date: "hace 2 semanas" },
        { author: "Michael B.", text: "Verdaderamente premium. Santi trae la experiencia completa de barbería a tu sala. El trabajo con navaja es impecable.", date: "hace 1 mes" },
        { author: "David L.", text: "La conveniencia de una visita a domicilio de clase mundial es algo a lo que no puedo renunciar. Precisión perfecta siempre.", date: "hace 3 días" }
      ],
      milestones: [
        { year: "2012", title: "La Chispa de Pereira", description: "Santi toma sus primeras máquinas en Colombia, practicando con amigos y familiares." },
        { year: "2018", title: "El Viaje al Norte", description: "Mudándose a Florida con un sueño, Santi comienza a perfeccionar sus habilidades en estudios de alto nivel." },
        { year: "2024", title: "Santi Bladez Élite", description: "Lanzando un servicio móvil 100% de conserjería, dedicado a los clientes más exigentes de la ciudad." }
      ],
      faq: [
        { q: "¿Qué incluye los $180?", a: "La Visita a Domicilio Signature es una experiencia todo incluido: viaje a su ubicación, consulta profunda, corte maestro, trabajo de barba y toalla caliente con productos premium." },
        { q: "¿Qué tan lejos viajas?", a: "Santi brinda su servicio móvil en todo el sur de Florida. Para ubicaciones muy alejadas del núcleo metropolitano, puede aplicar un pequeño cargo adicional." },
        { q: "¿Qué debo proporcionar?", a: "Solo una silla estándar y acceso a un tomacorriente. Santi trae la iluminación, las herramientas y el equipo profesional." }
      ]
    }
  },
  hours: {
    weekdays: "8:00 AM - 9:00 PM",
    saturday: "9:00 AM - 7:00 PM",
    sunday: "By Special Request Only"
  }
};
